import { apiClient } from "../axiosClient";

export interface Platform {
  id: string;
  platform_name: string;
}

export const getPlatforms = async (search = ""): Promise<Platform[]> => {
  const response = await apiClient.get("/master/platforms", {
    params: {
      isActive: true,
      q: search,
    },
  });

  return (response.data?.data || []).map((item: any) => ({
    id: item.id,
    platform_name: item.platform_name,
  }));
};